import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { Radio, Video, Activity } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface PixelKPIsProps {
  activePixels: number;
  trackedVideos: number;
  lastActivity: string | null;
}

export function PixelKPIs({ activePixels, trackedVideos, lastActivity }: PixelKPIsProps) {
  useLanguage();
  const kpis = [
    {
      icon: Radio,
      value: activePixels,
      label: translateInterfaceText("Pixels ativos"),
    },
    {
      icon: Video,
      value: trackedVideos,
      label: translateInterfaceText("Vídeos rastreados"),
    },
    {
      icon: Activity,
      value: lastActivity || 'Nenhuma atividade',
      label: lastActivity ? translateInterfaceText("Última atividade detectada") : translateInterfaceText("Aguardando primeiro evento"),
      isText: true,
      tooltip: !lastActivity ? translateInterfaceText("Assim que um evento for detectado, ele aparece aqui.") : undefined,
    },
  ];

  return (
    <TooltipProvider>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        {kpis.map((kpi, index) => {
          const content = (
            <div
              className="bg-white border border-[#E5E7EB] rounded-xl px-5 py-4 flex items-center gap-4"
            >
              <div className="w-10 h-10 rounded-full bg-blue-50 flex items-center justify-center shrink-0">
                <kpi.icon className="w-5 h-5 text-[#437DFF]" />
              </div>
              <div>
                <div className={`font-bold text-[#111] ${kpi.isText ? 'text-sm' : 'text-2xl'}`}>
                  {kpi.value}
                </div>
                <div className="text-xs text-[#64748B]">{kpi.label}</div>
              </div>
            </div>
          );

          if (kpi.tooltip) {
            return (
              <Tooltip key={index}>
                <TooltipTrigger asChild>
                  {content}
                </TooltipTrigger>
                <TooltipContent>
                  <p>{kpi.tooltip}</p>
                </TooltipContent>
              </Tooltip>
            );
          }

          return <div key={index}>{content}</div>;
        })}
      </div>
    </TooltipProvider>
  );
}
